<script setup lang="ts">
import axios from 'axios'
import { notifyError, fullLogOTT, getDevicesFromTree } from '@/utils/helpers'
import type { OmniTBObjectTree } from '@/types/omniTBCustomer'

definePage({
  meta: {
    id: 'ott-test',
    title: 'OTT Test',
    requiresAuth: false,
    disableLayout: true
  },
})

const apiOmniAnon = axios.create({
  baseURL: import.meta.env.VITE_OMNI_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let apiConfig: { headers: Record<string, string> } | null = null
const isLoading = ref(true)
const wmeters = ref<OmniTBObjectTree[]>([])

onMounted(async () => {
  isLoading.value = true

  const log = await fullLogOTT(apiOmniAnon, window, null)
  if (log == null || log.error != null || log.customer == null || log.customer.objectTree == null) {
    notifyError(log?.error ?? 'Unknown error during OTT login')
    isLoading.value = false
    return
  }

  apiConfig = { headers: { 'X-APIKey': log.apiKey, 'X-ThingsBoard': log.tbToken } }

  wmeters.value = getDevicesFromTree(log.customer.objectTree, 'WMETER')

  isLoading.value = false
})
</script>

<template>
  <div v-if="isLoading">Chargement...</div>
  <div v-else>
    <p v-for="wmeter in wmeters" :key="wmeter.id.id">{{ wmeter.name }} (ID: {{ wmeter.id.id }})</p>
  </div>
  <v-footer app>
    <v-spacer/>
    <v-defaults-provider :defaults="{ VBtn: { variant: 'text', size: 'x-small' } }">
      <AppNotification />
      <ButtonSettings />
    </v-defaults-provider>
  </v-footer>
</template>
